import React from "react";
import { Fade } from "react-awesome-reveal";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

const ComponentName: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate()
  return (
    <div className="">
      <div className="">
        <div className="text-[#181512] text-[45px] py-[78px] font-[700] text-center h5:pt-0 h5:pb-[20px] h5:text-[30px]">更多關於</div>
      </div>
      <div className="relative">
        <div className='w-[960px] mx-auto relative mt-[30px] pb-[100px] h5:mt-0 h5:w-full h5:pb-[50px]'>
          <div className="flex h5:block">
            <div className="flex-1">
              <Fade cascade={true} direction="down" delay={0} duration={600} triggerOnce={true}>
                <div className="px-[15px] cursor-pointer h5:px-[36px] h5:pb-20"
                  onClick={() => {
                    navigate('/about/whyUs')
                  }}>
                  <img src={require('../../../assets/image/video/icon5.png')} alt=""
                    className='w-full h-[360px] h5:h-[252px] object-cover hover:opacity-70  duration-300' />
                  <div className="text-[#181512] text-[22px] font-bold text-center my-[30px] h5:my-16">關於詩肯</div>
                </div>
              </Fade>
            </div>
            <div className="flex-1">
              <Fade cascade={true} direction="down" delay={0} duration={600} triggerOnce={true}>
                <div className="px-[15px] cursor-pointer h5:px-[36px] h5:pb-20"
                  onClick={() => {
                    navigate('/about/history')
                  }}>
                  <img src={require('../../../assets/image/video/icon6.png')} alt=""
                    className='w-full h-[360px] h5:h-[252px] object-cover hover:opacity-70  duration-300' />
                  <div className="text-[#181512] text-[22px] font-bold text-center my-[30px] h5:my-16">歷史和歷程碑</div>
                </div>
              </Fade>
            </div>
          </div>
        </div>
        <img src={require("../../../assets/image/icon7.png")}
          className='absolute left-0 top-[220px] w-[100%] h-[540px] z-[-1]
          h5:w-[100%] h5:top-[auto] h5:bottom-[0px]
          '
          alt="" />
      </div>
    </div>
  );
};

export default ComponentName;
